import { motion } from "framer-motion";
import { Button } from "../components/ui/button";

const FounderSpotlight = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className="bg-white py-24 lg:py-32 overflow-hidden"
      data-testid="founder-spotlight-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left Column - Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5 relative overflow-hidden"
          >
            <div className="relative overflow-hidden shadow-xl">
              <img
                src="https://customer-assets.emergentagent.com/job_mheshe-legal/artifacts/mxvvvsdm_Mheshe%20Attorneys%20.jpeg"
                alt="Ms. Nande Mheshe - Director"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 border border-brand-gold/30" />
            </div>
            <div className="absolute -bottom-4 -left-4 w-24 h-24 border-2 border-brand-gold hidden lg:block" />
          </motion.div>

          {/* Right Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-7"
          >
            <p className="uppercase tracking-[0.2em] text-xs font-bold text-brand-gold mb-4">
              Our Founder
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl font-semibold text-charcoal leading-tight tracking-tighter mb-4">
              Ms. Nande Mheshe
            </h2>
            <p className="text-brand-gold font-sans text-sm sm:text-lg mb-6 sm:mb-8">
              Director | Attorney | Conveyancer | Notary Public
            </p>

            <div className="relative mb-6 sm:mb-8">
              <span className="font-serif text-5xl sm:text-6xl text-brand-gold/30 absolute -top-4 -left-2">"</span>
              <blockquote className="text-charcoal/80 font-serif text-xl sm:text-2xl italic leading-relaxed pl-8">
                Together, we continue to open doors, build cross-border
                partnerships, and lift as we rise.
              </blockquote>
            </div>

            <p className="text-charcoal/60 font-sans text-base sm:text-lg mb-4 leading-relaxed">
              As a triple-admitted legal professional with expertise in both
              South African and Angolan law, Ms. Mheshe brings unparalleled
              cross-border legal capabilities. Her extensive experience in
              corporate governance, commercial law, and property transactions
              positions Mheshe Attorneys as a leading firm in the Eastern Cape
              and beyond.
            </p>

            <p className="text-charcoal/60 font-sans text-base sm:text-lg mb-8 sm:mb-10 leading-relaxed">
              Mheshe Attorneys serve on various boards at both provincial and national levels, contributing to governance and strategic oversight.
            </p>

            <Button
              onClick={() => scrollToSection("#lead-capture")}
              className="btn-gold w-full sm:w-auto px-8 py-4 text-sm sm:text-base font-semibold uppercase tracking-wider rounded-none"
              data-testid="founder-book-consultation-btn"
            >
              Book a Consultation with Our Team
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FounderSpotlight;
